export default __webpack_public_path__ + "static/untitled-sans-web-medium-e9c57ca9e5adf8333cde6aeba5b787ae.woff";